import { Checkbox, Input } from "antd";
import { useCommonService } from "pages/service";
import { useEffect, useState, useRef } from "react";
import { INVESTIGATE_TAG_DISPLAY } from "lib/constants";
import { formatAlertTagDisplayToSDK } from "lib/utils";
import type { SnapshotDataTypes } from "pages/service";
export default function Notes({ streamingCamera, note, onChange }) {
  const { takeSnapshot } = useCommonService();
  const [imageSrc, setImageSrc] = useState("");
  const cameraIdRef = useRef(0);
  const [tags, setTags] = useState(() => {
    return Object.values(INVESTIGATE_TAG_DISPLAY).map((tag) => {
      return {
        name: tag,
        value: formatAlertTagDisplayToSDK(tag as INVESTIGATE_TAG_DISPLAY),
        checked: false,
      };
    });
  });

  useEffect(() => {
    setTags((oldTags) => {
      note.types?.forEach((type) => {
        oldTags.find((tag) => tag.value === type).checked = true;
      });
      return [...oldTags];
    });
  }, [note.types]);

  useEffect(() => {
    if (!streamingCamera) return;
    cameraIdRef.current = +streamingCamera?.cameraId;
    takeSnapshot(
      [streamingCamera],
      streamingCamera?.orgId,
      (snapshots: SnapshotDataTypes[]) => {
        if (snapshots?.at(0)?.id == cameraIdRef.current) {
          setImageSrc(URL.createObjectURL(snapshots?.at(0)?.blob));
        }
      },
    );
  }, [streamingCamera]);

  const onNoteChange = (value) => {
    onChange({ ...note, note: value });
  };
  const onCheckChange = (item, e) => {
    const newTags = tags.map((tag) => {
      if (tag.value === item.value) {
        return { ...tag, checked: e };
      }
      return tag;
    });
    setTags(newTags);
    onChange({
      ...note,
      types: newTags.filter((tag) => tag.checked).map((tag) => tag.value),
    });
  };
  return (
    <div style={{ marginBottom: "16px" }}>
      <div className="flex justify-center bg-zinc-100 aspect-video w-full">
        <img src={imageSrc} />
      </div>

      <div style={{ margin: "16px 0px 8px 0px" }}>Note</div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "8px",
        }}
      >
        {tags.map((item) => {
          return (
            <div
              onClick={() => {
                const matchedTag = tags.find((tag) => tag.name === item.name);
                onCheckChange(item, !matchedTag.checked);
              }}
              key={item.name}
              style={{
                cursor: "pointer",
                height: "40px",
                backgroundColor: item.checked
                  ? "rgba(220, 231, 253, 1)"
                  : "rgba(245, 245, 245, 1)",
                borderRadius: "8px",
                padding: "2px 8px",
                display: "flex",
                //justifyContent: "space-around",
                alignItems: "center",
              }}
            >
              <Checkbox
                checked={item.checked}
                onChange={(e) => {
                  e.stopPropagation();
                  onCheckChange(item, e.target.checked);
                }}
              />
              <span
                style={{
                  fontSize: "16px",
                  fontWeight: "600",
                  color: item.checked
                    ? "rgba(62, 131, 246, 1)"
                    : "rgba(34, 34, 34, 1)",
                  flexGrow: 1,
                  textAlign: "center",
                }}
              >
                {item.name}
              </span>
            </div>
          );
        })}
      </div>
      <div style={{ marginTop: "16px" }}>
        <Input.TextArea
          value={note.note}
          rows={4}
          placeholder="Enter note"
          onChange={(e) => onNoteChange(e.target.value)}
        />
      </div>
    </div>
  );
}
